import { Muted } from "@/components/typography";
import { pageFileUrl, type ReviewPage } from "../lib/review-client";

export function ReviewStage({ page, onExpand }: { page: ReviewPage | undefined; onExpand: () => void }) {
  if (!page) {
    return (
      <div className="flex h-full items-center justify-center">
        <Muted>No pages.</Muted>
      </div>
    );
  }
  return (
    <button type="button" onClick={onExpand} className="flex h-full w-full items-center justify-center p-4">
      <img
        src={pageFileUrl(page.id, page.sha256)}
        alt="Selected page"
        className="max-h-full max-w-full rounded-md object-contain"
        style={page.rotation ? { transform: `rotate(${page.rotation}deg)` } : undefined}
      />
    </button>
  );
}
